import { action } from 'easy-peasy'

export const menusModel = {
  nav: {
    isNavOpen: false,

    // ACTIONS
    openNav: action(state => ({
      ...state,
      isNavOpen: true,
    })),

    closeNav: action(state => ({
      ...state,
      isNavOpen: false,
    })),

    toggleNav: action(state => ({
      ...state,
      isNavOpen: !state.isNavOpen,
    })),
  },
}
